import moment from 'moment';
import BotReportApi from 'api/bot-report';
import NoRecords from 'components/ui/DataGrid/NoRecords';
import DataGridWithPagination from 'components/ui/DataGrid/DataGridWithPagination';
import ContentSpinner from 'components/ui/ContentSpinner';

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Status } from 'helpers/StatusHelper';

const BotReportData = ({ reportId, search = '' }) => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [current_page, setPage] = useState(1);
  const [is_loading, setLoading] = useState(false);

  const fetchData = async (reportId, page = 1, search) => {
    setLoading(true);

    try {
      const response_data = await BotReportApi.fetchData(reportId, { page, search });
      setData(response_data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => fetchData(reportId, current_page, search), [reportId, current_page, search]);

  if (is_loading) {
    return <ContentSpinner />;
  }

  const { work_objects, report, count } = data;

  if (!work_objects || (!report.columns && !report.filters)) {
    return <NoRecords />;
  }

  const work_object_setting = report.schemas.find(item => item.id === 'work_object');

  const schema = work_object_setting.schema || {};
  const properties = schema.properties || {};

  schema.properties.created_at = { title: t('columns.created_at'), format: 'datetime' };
  schema.properties.updated_at = { title: t('columns.updated_at'), format: 'datetime' };
  schema.properties.status = { title: t('columns.status'), format: 'status' };

  const fixed_columns = ['created_at', 'updated_at', 'status', 'createdAt', 'updatedAt'];

  const formatters = {
    datetime: value => moment(value).format(t('formats.datetime')),
    date: value => moment(value).format(t('formats.date')),
    status: value => t(Status[value].tkey).toUpperCase(),
    text: value => value || '',
  };

  const formatter = (key, type = 'text', { row }) => {
    const format = formatters[type];

    if (fixed_columns.includes(key)) {
      return format(row[key]);
    }

    return format(row.payload[key]);
  };

  const columns = report.columns.map(key => {
    const prop = properties[key] || {};
    return { key, name: prop.title, width: 'auto', resizable: true, formatter: formatter.bind(this, key, prop.format || 'text') };
  });

  const handlePageChange = page => {
    setPage(page);
    fetchData(reportId, page);
  };

  return <DataGridWithPagination grid={{ columns, rows: work_objects }} pagination={{ current_page, count, onPageChange: handlePageChange }} />;
};

export default BotReportData;
